// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"_2N0TSUNx5ZTvjjhofjifRQ","Logo":"LWn5rbdkk_NY51mtVRbXz","DesktopOnly":"_13qkdC-3BwacAK4W2Nt4MC"};